module.exports = __webpack_public_path__ + "img/home_specialist_photo.png";